import { render, staticRenderFns } from "./indexCommunity.vue?vue&type=template&id=2ae9bae9&scoped=true"
import script from "./indexCommunity.vue?vue&type=script&lang=js"
export * from "./indexCommunity.vue?vue&type=script&lang=js"
import style0 from "./indexCommunity.vue?vue&type=style&index=0&id=2ae9bae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae9bae9",
  null
  
)

export default component.exports